<template>
  <div>
    <!-- <router-view></router-view> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
//
import projectConfig from '@/core/config';
// const requireContext = require.context('@/api/myController', false, /\.js$/);

export default {
  created() {},
  data() {
    return {};
  },
  // errorCaptured(err, vm, info) {
  //   console.log("err.name:", err.name);
  //   console.log("err.message:", err.message);
  //   return false; // 阻止错误继续向上冒泡
  // },
  watch: {
    $route: {
      handler(newValue) {
        // 缓存字典
        document.title = projectConfig.projectName;
        if (newValue.meta && newValue.meta.title) {
          document.title += ' - ' + newValue.meta.title;
        }
      },
      immediate: true
    }
  }
};
</script>
<style>
/* #app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: absolute;
  top: 0;
  left: 0;
  padding: 25px;
  width: 100%;
  height: 100%;
  background: #f7f7f7;
  box-sizing: border-box;
} */
</style>
<style lang="less">
.el-input.is-disabled .el-input__inner,
textarea:disabled {
  color: #666;
  font-weight: 700;
}

// hiprint 拖拽图片
.hiprint-printElement-image-content {
  img {
    content: url("~@/assets/img/none.png");
  }
}

.hiprint-printPaper .hiprint-paperNumber {
  width: 95pt;
}

.htmlDiv {
  max-width: 100% !important;
}

.title--font {
  color: #1476c3;
  position: relative;
  flex: 1;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
}

.title--single_font {
  border: 1px solid red;
  display: inline-block;
  margin: 0px auto;
  color: #1476c3;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
  z-index: 999;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
        justify-content:center; */
}

.title--newFont {
  color: #1476c3;
  position: relative;
  flex: 1;
  text-align: left;
  font-size: 1.5em;
  font-weight: bold;
}

.title--font.sm {
  color: rgb(120, 120, 120);
  position: relative;
  flex: 1;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

.hiprint-printElement-tableTarget,
.hiprint-printElement-tableTarget tr,
.hiprint-printElement-tableTarget td {
  padding: 2pt !important;
}
</style>
